import { loadStripe, type Stripe } from '@stripe/stripe-js'

let stripePromise: Promise<Stripe | null> | null = null

export const getStripe = () => {
  if (!stripePromise) {
    stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLIC_KEY)
  }
  return stripePromise
}

export const createCardElement = (stripe: Stripe) => {
  const card = stripe
    .elements({
      fonts: [
        {
          family: 'Dacr',
          src: 'url("/fonts/dacr/Book20.woff2")',
          weight: '400',
        },
      ],
    })
    .create('card', {
      classes: {
        base: 'font-primary flex items-center w-full h-[48px] px-[17px] bg-gray-200/25 tablet-h:bg-transparent rounded-md text-gray-800 outline-hidden tablet-h:outline-offset-0! tablet-h:focus:outline-green-200/50! border border-transparent tablet-h:border-gray-200/75! tablet-h:hover:border-gray-300/50! tablet-h:focus:border-green-500!',
        invalid: 'border-red-500',
      },
      style: {
        base: {
          fontFamily: 'Dacr',
          color: '#292C30',
          fontSize: '14px',
        },
      },
    })

  return card
}
